import { makeStyles } from '@material-ui/styles'

export const useStyle = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flexWrap: 'wrap'
  },
  stageName: {
    // Match the "Policy Processing" page title styling.
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.0015em',
    color: '#000000'
  },
  actions: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap'
  },
  screeningPanel: {
    background: '#F8F9FB',
    borderLeft: '3px solid #FBA92D',
    borderRadius: '4px',
    padding: '8px 14px'
  },
  // In the header the panel takes its own line under the stage and its actions.
  screeningPanelInline: {
    flexBasis: '100%'
  },
  screeningTitle: {
    display: 'block',
    fontFamily: 'Open Sans',
    fontWeight: 600,
    fontSize: '11px',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: '#8A8A8A',
    marginBottom: '4px'
  },
  screeningReason: {
    fontFamily: 'Open Sans',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '20px',
    color: '#333333'
  },
  screeningSubject: {
    fontWeight: 600,
    color: '#000000'
  },
  noPerm: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    color: '#8A8A8A'
  }
}))
